import { useState } from "react";
import CountUp from "react-countup";
import AvatarButton from "./AvatarButton";

const Solver = ({ round }) => {
  const [pointsCounted, setPointsCounted] = useState(false);
  const [bonusPointsCounted, setBonusPointsCounted] = useState(false);
  const timeTaken = Math.round(round.time_taken * 10) / 10;

  return (
    <div className="flex flex-col items-center">
      <div className="flex items-center gap-x-1">
        <AvatarButton user={round.solver} ring />
        <strong className="ml-2">{round.solver.username}</strong>
        <span>solved in</span>
        <strong>{timeTaken}s</strong>
      </div>
      <p>
        <span
          className={`inline-block transition ${
            pointsCounted
              ? "text-primary-600 font-bold animate-heartbeat-once"
              : "text-gray-500"
          }`}
        >
          +
          <CountUp
            end={round.score.base_points}
            delay={0.5}
            duration={0.5}
            onEnd={() => {
              setPointsCounted(true);
            }}
          />
        </span>{" "}
        Points
      </p>
      {round.score.bonus ? (
        <p>
          <span
            className={`inline-block transition ${
              bonusPointsCounted
                ? "text-primary-600 font-bold animate-heartbeat-once"
                : "text-gray-500"
            }`}
          >
            +
            <CountUp
              end={round.score.bonus}
              delay={1}
              duration={0.5}
              onEnd={() => {
                setBonusPointsCounted(true);
              }}
            />
          </span>{" "}
          {round.score.bonus_reason}
        </p>
      ) : null}
    </div>
  );
};
export default Solver;
